import { createFileRoute } from "@tanstack/react-router";

import { OrganizationSettingsPanel } from "../components/settings/OrganizationSettings";
import { redirectUnlessOfferedOnClient } from "../components/settings/settingsClientBridges";

export const Route = createFileRoute("/settings/organizations")({
  // Keyed off the Connect bridge, not `isElectron`: where there is no bridge there is nothing to
  // sign into. Configured browser clients use the same account surface as Desktop.
  beforeLoad: () => redirectUnlessOfferedOnClient("/settings/organizations"),
  component: OrganizationSettingsPanel,
});
